var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.668,
    viewBox: "0 0 16 15.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_69309",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 69309",
    transform: "translate(-21.923 -22.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_4",
    "data-name": "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435 4",
    d: "M-4901.246,10057.282l-5.753-5.754-5.753,5.754a1.312,1.312,0,0,1-1.86,0,1.316,1.316,0,0,1,0-1.863l5.325-5.325a.367.367,0,0,0,0-.518l-5.325-5.328a1.313,1.313,0,0,1,0-1.86,1.312,1.312,0,0,1,1.86,0l5.753,5.753,5.753-5.753a1.312,1.312,0,0,1,1.86,0,1.314,1.314,0,0,1,0,1.86l-5.325,5.324a.37.37,0,0,0,0,.521l5.325,5.325a1.317,1.317,0,0,1,0,1.863,1.3,1.3,0,0,1-.929.387A1.311,1.311,0,0,1-4901.246,10057.282Z",
    transform: "translate(4936.923 -10019.95)",
    fill: "#44444f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose4);
export default __webpack_public_path__ + "static/media/close4.334743d5.svg";
export { ForwardRef as ReactComponent };